<template>
  <div id="bodyDiveHome" v-wechat-title="titleTop">
    <NativeBar ref="dive" v-model="NativeBarId" />
    <!-- <div class="topLogo" ><img src="/dive/logo.png"></div> -->
    <div class="searchBar">
      <van-field v-model="searchKey" readonly placeholder=" 潜店、潜点、攻略" style="background-color: #eee;line-height:0.7em;heigth:0.7em;font-size:0.8em;" />
    </div>
    <div class="topAd">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(item, index) in diveAd" :key="index">
          <img :src="item.img" @click="jumpUrl(item.url)">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="topIcon">
      <van-row>
        <van-col span="6" @click="onClickDiveLog(undefined)"><van-icon class="iconfont icondivelog" :color="GetDiveMainBack()" /><br><span>潜水日志</span></van-col>
        <van-col span="6" @click="onDiveCenterList"><van-icon class="iconfont icondiveshop" :color="GetDiveMainBack()" /><br><span>我的潜店</span></van-col>
        <van-col span="6" @click="onTopDiver"><van-icon class="iconfont iconbangdan" :color="GetDiveMainBack()" /><br><span>风云榜</span></van-col>
        <van-col span="6" @click="onCerificate"><van-icon class="iconfont iconcard" :color="GetDiveMainBack()" /><br><span>潜水证书</span></van-col>
      </van-row>
    </div>

    <div class="baseRect">
      <div class="baseTitle" :style="'color: '+GetDiveMainBack()+';'">课程/行程</div>
      <div class="baseMore"><i class="iconfont iconmore" @click="onTripList" /></div>
      <div v-if="tripList.length<=0" class="baseEmpty" @click="onClickDiveLog(undefined)">
        还没有行程
      </div>
      <div v-for="item in tripList" :key="item.studentId" class="tripRect" @click="onTrip(item)">
        <div class="title">{{ item.title }}</div>
        <div class="body">{{ item.about }}</div>
        <div class="tag"><van-tag :color="GetDiveMainBack()" round type="primary">{{ GetEnumText('Em_LearningState',item.state) }}</van-tag>
          <br><van-tag v-if="item.isNeedOnlinePay" :color="GetDiveMainBack()" round>需在线支付</van-tag>
        </div>
      </div>
      <!-- <div class="tripRect">
        <div class="title">AdvanceOpenWater课程</div>
        <div class="body">等待开课</div>
        <div class="tag"><van-tag round>待开课</van-tag></div>
      </div> -->
    </div>
    <div class="baseRect">
      <div class="baseTitle" :style="'color: '+GetDiveMainBack()+';'">潜水日志</div>
      <div class="baseMore" @click="onClickDiveLog(undefined)"><i class="iconfont iconmore" /></div>
      <div v-if="divelogList.length<=0" class="baseEmpty" @click="onClickDiveLog(undefined)">
        还没有日志<br>
        +
      </div>
      <div v-for="(item,index) in divelogList" :key="index" class="diveLog" @click="onClickDiveLog(item.diveLogId)">
        <div class="titleTop">{{ formatDate(item.dateOfStar,"yyyy.MM.dd") }}  {{ item.country }} {{ item.divePlaceName?item.divePlaceName:item.divePlaceNameEng }}</div>
        <van-row class="title">
          <van-col span="4">潜水次数</van-col>
          <van-col span="1" />
          <van-col span="4">开始时间</van-col>
          <van-col span="1" />
          <van-col span="4">潜水时间</van-col>
          <van-col span="1" />
          <van-col span="4">最大深度</van-col>
          <van-col span="1" />
          <van-col span="4">水域温度</van-col>
        </van-row>
        <van-row class="body" :style="'color: '+GetDiveMainBack()+';'">
          <van-col span="4"><b>{{ item.diveNum }}</b></van-col>
          <van-col span="1"><span>|</span></van-col>
          <van-col span="4">{{ formatDate(item.dateOfStar,"h:mm") }}</van-col>
          <van-col span="1"><span>|</span></van-col>
          <van-col span="4">{{ item.dateOfLen?ShowFloat(item.dateOfLen)+'min':'-' }}</van-col>
          <van-col span="1"><span>|</span></van-col>
          <van-col span="4">{{ item.maxDeep?ShowFloat(item.maxDeep)+'m':'-' }}</van-col>
          <van-col span="1"><span>|</span></van-col>
          <van-col span="4">{{ item.temparature?ShowFloat(item.temparature)+'℃':'-' }}</van-col>
        </van-row>
      </div>
    </div>
    <div class="baseRect" style="padding-bottom:0.2em;">
      <div class="baseTitle" :style="'color: '+GetDiveMainBack()+';'">潜水教练</div>
      <div class="baseMore"><i class="iconfont iconmore" /></div>
      <van-swipe class="my-swipe" :autoplay="10000" :indicator-color="GetDiveMainBack()">
        <van-swipe-item v-for="coach in coachList" :key="coach.coach.userId">
          <div class="coachRect">
            <div class="coachInfo" @click="onCoach(coach.coach.userId)">
              <div class="icon">
                <van-image
                  width="5em"
                  height="5em"
                  round
                  fit="contain"
                  :src="coach.coach.icon?coach.coach.icon:'/dive/defaultIcon.jpg'"
                />
              </div>
              <div class="bodyRect">
                <van-row>
                  <van-col span="16" class="name">{{ coach.coach.proName }}&nbsp;<van-tag v-if="coach.coach.pop" :color="GetDiveMainBack()" round type="primary">{{ coach.coach.pop }}</van-tag>
                  </van-col>
                  <van-col span="8" class="info rigth">{{ coach.coach.diveShopName }}</van-col>
                </van-row>
                <div class="body">
                  {{ coach.coach.about }}
                </div>
              </div>
            </div>
            <div v-for="comment in coach.comment" :key="comment.commentId" class="commentRect">
              <div class="icon">
                <van-image
                  width="3em"
                  height="3em"
                  round
                  fit="contain"
                  src="/dive/defaultIcon.jpg"
                />
                <div class="name">{{ comment.userName }}</div>
              </div>
              <div v-if="!comment.res || comment.res.length <= 0" class="body">
                <div class="fontNoPic">
                  {{ comment.about }}
                </div>
              </div>
              <div v-if="comment.res &&comment.res.length>0" class="body">
                <div class="fontPic">
                  {{ comment.about }}
                </div>
                <van-image
                  v-for="(img,index) in comment.res"
                  :key="index"
                  class="img"
                  width="2.5em"
                  height="2.5em"
                  fit="cover"
                  :src="img"
                  @click="showPreview(comment.res)"
                />
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <bindPhone v-model="showBindPhone" show-type="reg" @finish="loadTripList" />
    <div class="baseEmpty" />
  <!-- <div class="baseRect">
      <div class="baseTitle" :style="'color: '+GetDiveMainBack()+';'">课程/行程</div>
      <div class="baseMore"><i class="iconfont iconmore" /></div>
    </div> -->

  </div>
</template>
<script>
import request from '@/utils/request'
import { Icon, Button, Field, Swipe, SwipeItem, Lazyload, Tag, Image, ImagePreview } from 'vant'
import { GetEnbaleDiveComment, getUrlKey, ShowFloat, ShowMoney, GetEnumText, formatDate, getUserBase, jumpUrl } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import NativeBar from '@/components/NativeBar'
import bindPhone from '@/components/bindPhone'
import commondata from '@/commondata.js'

export default {
  name: 'DiveHome',
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Field.name]: Field,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Lazyload.name]: Lazyload,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [ImagePreview.name]: ImagePreview,
    NativeBar,
    bindPhone
  },
  beforeRouteLeave(to, from, next) {
    this.offsetTopBody = document.getElementById('bodyDiveHome').scrollTop
    next()
  },
  data() {
    return {
      titleTop: '',
      NativeBarId: '',
      offsetTopBody: 0,
      searchKey: undefined,
      diveAd: [],
      coachList: [],
      divelogList: [],
      tripList: [],
      showBindPhone: false,
      checkReg: false
    }
  },

  activated() {
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'dive'
    }, 0)
    document.getElementById('bodyDiveHome').scrollTop = this.offsetTopBody
    this.loadBaseData()
  },
  created() {
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'dive'
    }, 0)
    var checkReg = getUrlKey('reg')
    if (checkReg) {
      this.checkReg = true
    } else {
      this.checkReg = false
    }
    getUserBase(data => {
      this.titleTop = GetDiveTitle()
      if (this.checkReg && !data.bindPhone) {
        this.showBindPhone = true
        this.checkReg = false
      }
    }, true)
    this.loadCoachList()
    this.loadDiveLogList()
    this.loadTripList()
  },
  methods: {
    GetEnbaleDiveComment,
    jumpUrl,
    ShowFloat,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    loadBaseData() {
      setTimeout(() => {
        if (!commondata.storeBase) {
          this.loadBaseData()
          return
        }
        this.diveAd = commondata.storeBase.diveAd
      }, 100)
    },
    loadTripList() {
      request({
        url: '/DiveTrip/GetDiveTripHome',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.tripList = response.data.rows
      })
    },
    loadCoachList() {
      request({
        url: '/DiveData/getCoacheRecommend',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.coachList = response.data
        if (!GetEnbaleDiveComment()) {
          this.coachList.forEach(el => {
            el.comment = []
          })
        }
      })
    },
    loadDiveLogList() {
      request({
        url: '/Dive/getDiveLogHomeList',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.divelogList = response.data
      })
    },
    onClickDiveLog(id) {
      if (id) {
        this.$router.push('/dive/log/' + id)
      } else {
        this.$router.push('/dive/logList')
      }
    },
    showPreview(imgs) {
      ImagePreview(imgs)
    },
    onTripList() {
      this.$router.push('/divetrip')
    },
    onTrip(item) {
      console.log('onTrip', item)
      this.$router.push('/divetrip/trip/' + item.studentId)
    },
    onTopDiver() {
      this.$router.push('/dive/topDiver')
    },
    onCerificate() {
      this.$router.push('/my/myCerificate')
    },
    onDiveCenterList() {
      this.$router.push('/dive/diveCenterList')
    },
    onCoach(userId) {
      this.$router.push('/pro/coachHome/' + userId)
    }
  }
}
</script>
<style scoped>
.baseRect{
    margin-top: 0.5em;
    padding: 1em 1em;
    background-color: #fff;
    position: relative;
}
.baseRect .baseTitle{
    font-weight: 700;
    margin-bottom: 1em;
}
.baseRect .baseMore{
    position: absolute;
    right: 1em;
    color: #999;
    top:1em;
}
.baseRect .baseMore i{
    font-size: 0.7em;
}
.baseEmpty{
    height: 3.5em;
}

.topLogo{
    padding:0.5em 25vw;
    background-color: #fff;
}
.topLogo img{
    width: 100%;
}
.searchBar {

    padding: 1em;
    background-color: #fff;
}
.searchBar :first-child{
    border-radius: 10em;
}
.topAd{
   padding: 0 1em;
    background-color: #fff;
}
.topAd img{
    width: 100%;
    border-radius: 0.5em;
  overflow: hidden;
}
.topIcon{
     padding: 0 1em 1em 1em;
    background-color: #fff;
    text-align: center;
}
.topIcon .iconfont{
  padding: 0.5em 0;
  font-size: 1.5em;
}
.topIcon span{
  font-size: 0.6em;
  color: #646566;
}
.baseEmpty{
  text-align: center;
  color: #999;
  padding:1em 0;
  font-size: 0.7em;
}
.tripRect{
    position: relative;
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
    padding-right: 7em;
    border-bottom: 1px solid #f5f5f5;
}
.tripRect .title{
    font-size: 0.8em;
    margin-bottom: 0.5em;
}
.tripRect:last-child{
    border-bottom:none;
     padding-bottom: 0;
    margin-bottom: 0;
}
.tripRect .body{
    font-size: 0.7em;
    margin-top: 0em;
    color:#999;

}
.tripRect .tag{
    position: absolute;
    text-align: right;
    right: 0em;
    top:0.5em;
    width: 7em;
}
.diveLog{
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
}
.diveLog:last-child{
    border-bottom:none;
     padding-bottom: 0;
    margin-bottom: 0;
}
.diveLog .title{
    font-size: 0.6em;
    text-align: center;
    margin: 0.5em 0;
    color: #999;
}
.diveLog .titleTop{
    font-size: 0.8em;
}
.diveLog .body{
    font-size: 0.8em;
    text-align: center;
}
.diveLog .body span{
    color: #eee;
}

.coachRect{
    padding-bottom: 2em;
}
.coachRect .coachInfo
{
    position: relative;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
}

.coachRect .coachInfo .icon{
    width: 5em;
}
.coachRect .coachInfo .bodyRect{
    position: absolute;
    left:6em;
    top:0;
    right: 0;
}
.coachRect .coachInfo .bodyRect .info{
    font-size: 0.6em;
     margin-bottom: 0.5em;
}
.coachRect .coachInfo .bodyRect .name{
    font-size: 0.9em;
    margin-bottom: 0.5em;
}
.coachRect .coachInfo .bodyRect .body{
    font-size: 0.7em;
    color: #999;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}

.coachRect .commentRect{
    position: relative;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
}
.coachRect .commentRect:last-child{
    border-bottom:none;
    padding-bottom: 0;
    margin-bottom: 0;
}

.coachRect .commentRect .icon{
    width: 5em;
    text-align: center;

}
.coachRect .commentRect .icon .name{
    font-size: 0.7em;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.coachRect .commentRect .body{
    position: absolute;
    left:6em;
    top:0;
}
.coachRect .commentRect .body .img{
    margin:0.5em 0.5em 0 0;
    border-radius: 0.3em;
    overflow: hidden;
}
.coachRect .commentRect .body .fontPic{
    font-size: 0.7em;
     color: #999;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.coachRect .commentRect .body .fontNoPic{
    font-size: 0.7em;
     color: #999;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
}
</style>
